import { render, staticRenderFns } from "./StockOverview.vue?vue&type=template&id=280711c0&"
import script from "./StockOverview.vue?vue&type=script&lang=js&"
export * from "./StockOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBreadcrumbs,QBreadcrumbsEl,QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QInput,QTable,QTr,QTh,QDialog,QCard,QCardSection,QSpace,QSelect,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QBreadcrumbsEl,QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QInput,QTable,QTr,QTh,QDialog,QCard,QCardSection,QSpace,QSelect,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
